import React from 'react';
const Icon = {
    Base: (props) => {
        const { icon, className } = props;
        return React.createElement("img", { src: require(`assets/svgs/icons/${icon}.svg`), className: className, alt: `${icon} icon` });
    },
    Flag: (props) => {
        const { countryCode } = props;
        return (React.createElement("img", { src: require(`assets/flags/${countryCode}.png`), width: countryCode === 'ch' ? 15 : 24, height: 15, alt: `${countryCode} flag`, className: `flag ${countryCode === 'ch' ? 'ch' : ''}` }));
    },
    Spinner: () => {
        return React.createElement("img", { src: require('assets/svgs/input_spinner.svg'), alt: "spinner" });
    },
};
export default Icon;
